import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.agent.sidebar');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-agent-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.agent.sidebar/view.scss */
:host {
  display: flex;
  width: 100%;
  height: 100%;
}`],
})
export class PortalAgentSidebarComponent implements OnInit, OnDestroy {
    @Input() systemPrompt: string = '';
    @Input() title: string = 'AI Assistant';
    @Input() placeholder: string = '메시지를 입력하세요...';

    public messages: any[] = [];
    public input: string = '';
    public loading: boolean = false;
    public conversationId: string = '';
    public conversations: any[] = [];
    public showSidebar: boolean = true;
    public streaming: string = '';

    @ViewChild('messageArea') messageArea: ElementRef;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadConversations();
        await this.newConversation();
    }

    ngOnDestroy() { }

    public async newConversation() {
        const { code, data } = await wiz.call("create", {
            title: this.title,
            system_prompt: this.systemPrompt
        });
        if (code === 200) {
            this.conversationId = data.id;
            this.messages = [];
            await this.loadConversations();
        }
        await this.service.render();
    }

    public async loadConversations() {
        const { code, data } = await wiz.call("conversations", { page: 1, dump: 100 });
        if (code === 200) {
            this.conversations = data.rows;
        }
        await this.service.render();
    }

    public async selectConversation(conv: any) {
        this.conversationId = conv.id;
        const { code, data } = await wiz.call("conversation", { id: conv.id });
        if (code === 200) {
            this.messages = data.messages || [];
        }
        await this.service.render();
        this.scrollToBottom();
    }

    public async deleteConversation(conv: any, event: Event) {
        event.stopPropagation();
        await wiz.call("delete_conversation", { id: conv.id });
        this.conversations = this.conversations.filter(c => c.id !== conv.id);
        if (this.conversationId === conv.id) {
            await this.newConversation();
        }
        await this.service.render();
    }

    public toggleSidebar() {
        this.showSidebar = !this.showSidebar;
        this.service.render();
    }

    public async sendMessage() {
        if (!this.input.trim() || this.loading) return;

        const userMsg = this.input.trim();
        this.input = '';
        this.messages.push({ role: 'user', content: userMsg });
        this.loading = true;
        this.streaming = '';
        await this.service.render();
        this.scrollToBottom();

        try {
            const formData = new FormData();
            formData.append('conversation_id', this.conversationId);
            formData.append('message', userMsg);

            const appId = wiz.namespace;
            const response = await fetch(`/wiz/api/${appId}/stream`, {
                method: 'POST',
                body: formData
            });

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        const event = JSON.parse(line.slice(6));
                        if (event.type === 'delta') {
                            this.streaming += event.content;
                            await this.service.render();
                            this.scrollToBottom();
                        } else if (event.type === 'error') {
                            this.streaming += `\n[오류: ${event.message}]`;
                            await this.service.render();
                        }
                    }
                }
            }

            if (this.streaming) {
                this.messages.push({ role: 'assistant', content: this.streaming });
            }
        } catch (e: any) {
            this.messages.push({ role: 'assistant', content: `오류가 발생했습니다: ${e.message}` });
        }

        this.streaming = '';
        this.loading = false;
        await this.loadConversations();
        await this.service.render();
        this.scrollToBottom();
    }

    public onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    private scrollToBottom() {
        setTimeout(() => {
            if (this.messageArea?.nativeElement) {
                this.messageArea.nativeElement.scrollTop = this.messageArea.nativeElement.scrollHeight;
            }
        }, 50);
    }
}

export default PortalAgentSidebarComponent;